import "core-js/modules/es.array.push.js";
import { $h, Tips, basePost, U, baseGet, URL, SplitArray, urlParams } from '@/utils/util.js';
import zrcheadernomenu from '@/components/zrcheader/nomenu.vue';
import zrcfooter from '@/components/zrcfooter/index.vue';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
export default {
  name: 'RegisterView',
  components: {
    zrcheadernomenu,
    zrcfooter
  },
  data() {
    return {
      xzmenu: 1,
      //菜单选中

      curzdf: 1,
      dltel: '',
      //登录手机号码
      dlmima: '',
      //登录密码
      xingming: '',
      //姓名
      yanzma: ''
    };
  },
  created() {
    var that = this;
    setTimeout(() => {
      this.loadingStatus = false;
    }, 2000);
  },
  onLoad(option) {
    console.log('参数');
  },
  watch: {},
  methods: {
    //进入到具体的新闻内容
    goxinwen: function (id, xzmenu) {
      var that = this;
      router.push({
        path: '/newsdetail',
        query: {
          id: id,
          xzmenu: xzmenu
        }
      });
    },
    //进入到具体的活动点位
    menugo: function (path) {
      var that = this;
      router.push({
        path: path
      });
    },
    //提交保存任务1
    lijizhuce: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi',
        c: 'webpublic_api',
        a: 'dengluyanz'
      }, URL);
      var data = {
        curzdf: that.$data.curzdf,
        sjtel: that.$data.dltel,
        dlpass: that.$data.dlmima,
        xingming: that.$data.xingming,
        yanzma: that.$data.yanzma
      };
      basePost(url, data, function (res) {
        Tips('登录成功', 'success');
        //console.log('登录成功'+res);
        store.commit('SetZrctoken', res.data.info.zrctoken);
        router.push({
          path: '/huiyuan'
        });
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    }
  },
  mounted: function () {
    var that = this;
  }
};